var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 34,
    viewBox: "0 0 115 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 34H4.25926C1.91773 34 0 32.1276 0 29.8415V4.89055C0 2.60441 1.91773 0.732052 4.25926 0.732052H110.741C113.082 0.732052 115 2.60441 115 4.89055V29.8415C115 32.1276 113.082 34 110.741 34Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.741 1.39845C112.713 1.39845 114.317 2.96516 114.317 4.89055V29.8415C114.317 31.7669 112.713 33.3336 110.741 33.3336H4.25926C2.28722 33.3336 0.682546 31.7669 0.682546 29.8415V4.89055C0.682546 2.96516 2.28722 1.39845 4.25926 1.39845H110.741ZM110.741 0.732052H4.25926C1.91773 0.732052 0 2.60441 0 4.89055V29.8415C0 32.1276 1.91773 34 4.25926 34H110.741C113.082 34 115 32.1276 115 29.8415V4.89055C115 2.60441 113.082 0.732052 110.741 0.732052Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.393 9.25151C40.393 9.94598 40.1801 10.5022 39.7605 10.917C39.2782 11.4087 38.6499 11.6562 37.8801 11.6562C37.1443 11.6562 36.5161 11.4046 36.0007 10.9087C35.4842 10.4055 35.2266 9.78795 35.2266 9.04878C35.2266 8.30961 35.4842 7.69207 36.0007 7.19305C36.5161 6.693 37.1443 6.44141 37.8801 6.44141C38.2464 6.44141 38.5956 6.51522 38.9289 6.65245C39.2611 6.79072 39.5316 6.97785 39.7275 7.20865L39.2824 7.64737C38.9406 7.25335 38.4753 7.05894 37.8801 7.05894C37.3434 7.05894 36.8781 7.24192 36.483 7.61098C36.0923 7.98109 35.8963 8.46035 35.8963 9.04878C35.8963 9.63721 36.0923 10.1206 36.483 10.4907C36.8781 10.8556 37.3434 11.0428 37.8801 11.0428C38.4498 11.0428 38.9289 10.8556 39.3069 10.4866C39.5561 10.2423 39.6977 9.90543 39.735 9.47503H37.8801V8.87412H40.3547C40.3845 9.00408 40.393 9.12987 40.393 9.25151V9.25151Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3185 7.17093H41.994V8.75116H44.0895V9.35206H41.994V10.9323H44.3185V11.5446H41.3359V6.55859H44.3185V7.17093Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0917 11.5446H46.4336V7.17093H45.0078V6.55859H48.5185V7.17093H47.0917V11.5446V11.5446Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0586 11.5446V6.55859H51.7156V11.5446H51.0586Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6268 11.5446H53.9741V7.17093H52.543V6.55859H56.0579V7.17093H54.6268V11.5446Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7041 10.9004C62.2004 11.4046 61.5765 11.6562 60.8322 11.6562C60.0836 11.6562 59.4596 11.4046 58.956 10.9004C58.4534 10.3972 58.2031 9.77964 58.2031 9.04878C58.2031 8.31793 58.4534 7.70039 58.956 7.19721C59.4596 6.693 60.0836 6.44141 60.8322 6.44141C61.5722 6.44141 62.1962 6.693 62.6998 7.20137C63.2067 7.70871 63.4569 8.32208 63.4569 9.04878C63.4569 9.77964 63.2067 10.3972 62.7041 10.9004ZM59.4426 10.4824C59.8216 10.8556 60.2827 11.0428 60.8322 11.0428C61.3773 11.0428 61.8427 10.8556 62.2175 10.4824C62.5955 10.1092 62.7872 9.62993 62.7872 9.04878C62.7872 8.46763 62.5955 7.98837 62.2175 7.61514C61.8427 7.24192 61.3773 7.05478 60.8322 7.05478C60.2827 7.05478 59.8216 7.24192 59.4426 7.61514C59.0646 7.98837 58.8729 8.46763 58.8729 9.04878C58.8729 9.62993 59.0646 10.1092 59.4426 10.4824V10.4824Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3789 11.5446V6.55859H65.1775L67.6607 10.4364H67.6894L67.6607 9.47785V6.55859H68.3177V11.5446H67.6319L65.0316 7.47554H65.0029L65.0316 8.43823V11.5446H64.3789V11.5446Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0419 18.8235C56.0411 18.8235 54.4066 20.3102 54.4066 22.3614C54.4066 24.3959 56.0411 25.8982 58.0419 25.8982C60.0469 25.8982 61.6814 24.3959 61.6814 22.3614C61.6814 20.3102 60.0469 18.8235 58.0419 18.8235ZM58.0419 24.5051C56.944 24.5051 55.9995 23.6204 55.9995 22.3614C55.9995 21.0858 56.944 20.2166 58.0419 20.2166C59.1397 20.2166 60.0884 21.0858 60.0884 22.3614C60.0884 23.6204 59.1397 24.5051 58.0419 24.5051V24.5051ZM50.1101 18.8235C48.105 18.8235 46.4748 20.3102 46.4748 22.3614C46.4748 24.3959 48.105 25.8982 50.1101 25.8982C52.114 25.8982 53.7453 24.3959 53.7453 22.3614C53.7453 20.3102 52.114 18.8235 50.1101 18.8235ZM50.1101 24.5051C49.0112 24.5051 48.0635 23.6204 48.0635 22.3614C48.0635 21.0858 49.0112 20.2166 50.1101 20.2166C51.2079 20.2166 52.1524 21.0858 52.1524 22.3614C52.1524 23.6204 51.2079 24.5051 50.1101 24.5051ZM40.6715 19.9079V21.4112H44.3483C44.2408 22.2512 43.9533 22.8687 43.5125 23.2991C42.9758 23.8189 42.1399 24.3959 40.6715 24.3959C38.4088 24.3959 36.637 22.613 36.637 20.4038C36.637 18.1946 38.4088 16.4116 40.6715 16.4116C41.895 16.4116 42.7852 16.8784 43.4422 17.4835L44.5272 16.4241C43.6083 15.5674 42.3859 14.9094 40.6715 14.9094C37.5687 14.9094 34.9609 17.3743 34.9609 20.4038C34.9609 23.4332 37.5687 25.8982 40.6715 25.8982C42.3486 25.8982 43.6083 25.3617 44.5986 24.3554C45.6133 23.3646 45.9296 21.9715 45.9296 20.8466C45.9296 20.4973 45.8998 20.1761 45.8465 19.9079H40.6715ZM79.2668 21.0733C78.9676 20.2821 78.0444 18.8235 76.1639 18.8235C74.3005 18.8235 72.7491 20.2572 72.7491 22.3614C72.7491 24.3429 74.2845 25.8982 76.3428 25.8982C78.0071 25.8982 78.9676 24.9074 79.3626 24.3304L78.1275 23.5268C77.7154 24.1152 77.1542 24.5051 76.3428 24.5051C75.5368 24.5051 74.9586 24.1443 74.588 23.4332L79.434 21.4756L79.2668 21.0733V21.0733ZM74.3261 22.2512C74.2845 20.8872 75.4111 20.1886 76.2182 20.1886C76.8507 20.1886 77.3874 20.4973 77.5663 20.9392L74.3261 22.2512V22.2512ZM70.3873 25.683H71.9803V15.2867H70.3873V25.683ZM67.7785 19.6116H67.7253C67.3675 19.1978 66.685 18.8235 65.8203 18.8235C64.0059 18.8235 62.3469 20.3788 62.3469 22.3728C62.3469 24.3554 64.0059 25.8982 65.8203 25.8982C66.685 25.8982 67.3675 25.5208 67.7253 25.0945H67.7785V25.6019C67.7785 26.9544 67.0385 27.6811 65.8448 27.6811C64.8716 27.6811 64.2678 26.995 64.0187 26.418L62.6333 26.9825C63.0326 27.9202 64.09 29.0742 65.8448 29.0742C67.7125 29.0742 69.2884 28.0013 69.2884 25.3908V19.0387H67.7785V19.6116V19.6116ZM65.9566 24.5051C64.8588 24.5051 63.9399 23.6079 63.9399 22.3728C63.9399 21.1263 64.8588 20.2166 65.9566 20.2166C67.0385 20.2166 67.8914 21.1263 67.8914 22.3728C67.8914 23.6079 67.0385 24.5051 65.9566 24.5051V24.5051ZM86.7248 15.2867H82.9149V25.683H84.5036V21.7438H86.7248C88.4892 21.7438 90.2195 20.4973 90.2195 18.5148C90.2195 16.5332 88.4849 15.2867 86.7248 15.2867V15.2867ZM86.7663 20.2977H84.5036V16.7329H86.7663C87.9525 16.7329 88.6297 17.6945 88.6297 18.5148C88.6297 19.3194 87.9525 20.2977 86.7663 20.2977ZM96.5871 18.8038C95.4392 18.8038 94.2455 19.2986 93.7547 20.3954L95.1645 20.9724C95.468 20.3954 96.0259 20.2083 96.6158 20.2083C97.44 20.2083 98.2759 20.6917 98.2886 21.5453V21.6544C98.0011 21.4922 97.3857 21.2521 96.6286 21.2521C95.1102 21.2521 93.563 22.0682 93.563 23.5912C93.563 24.9843 94.8067 25.8815 96.2048 25.8815C97.2739 25.8815 97.8638 25.4106 98.2343 24.8627H98.2886V25.6663H99.823V21.6783C99.823 19.8351 98.4132 18.8038 96.5871 18.8038ZM96.3954 24.5009C95.8758 24.5009 95.1517 24.2493 95.1517 23.6204C95.1517 22.8157 96.0547 22.5069 96.8362 22.5069C97.5358 22.5069 97.8638 22.6577 98.2886 22.8562C98.1641 23.8189 97.3154 24.5009 96.3954 24.5009V24.5009ZM105.413 19.0315L103.587 23.5382H103.533L101.645 19.0315H99.9317L102.768 25.3295L101.15 28.8341H102.81L107.181 19.0315H105.413V19.0315ZM91.0926 25.683H92.6856V15.2867H91.0926V25.683Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89114 7.00465C8.64091 7.2604 8.49609 7.65858 8.49609 8.17423V26.5673C8.49609 27.0829 8.64091 27.4811 8.89114 27.7368L8.9529 27.793L19.5095 17.4903V17.247L8.9529 6.94436L8.89114 7.00465Z",
    fill: "url(#paint0_linear_3550_6425)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0228 20.9258L19.5078 17.4898V17.2466L23.027 13.8106L23.1058 13.8553L27.2735 16.1705C28.4629 16.8276 28.4629 17.9088 27.2735 18.57L23.1058 20.8811L23.0228 20.9258V20.9258Z",
    fill: "url(#paint1_linear_3550_6425)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.107 20.8815L19.509 17.3686L8.89062 27.7368C9.28567 28.1422 9.92988 28.1911 10.6625 27.7856L23.107 20.8815",
    fill: "url(#paint2_linear_3550_6425)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.107 13.8504L10.6625 6.94626C9.92988 6.54496 9.28567 6.59382 8.89062 6.99928L19.509 17.3633L23.107 13.8504Z",
    fill: "url(#paint3_linear_3550_6425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3550_6425",
    x1: 18.5722,
    y1: 26.7588,
    x2: 4.61827,
    y2: 12.4668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3550_6425",
    x1: 28.8223,
    y1: 17.367,
    x2: 8.21013,
    y2: 17.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3550_6425",
    x1: 21.1505,
    y1: 15.459,
    x2: 2.22785,
    y2: -3.92219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3550_6425",
    x1: 6.21777,
    y1: 33.8507,
    x2: 14.6676,
    y2: 25.1962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPlaystore);
export default __webpack_public_path__ + "static/media/footer-playstore.d9f99a11042d9dca0abec07951163e52.svg";
export { ForwardRef as ReactComponent };